import { EnaioWorkflowEventType } from "./EnaioWorkflowEventType";

export class EnaioEventType {
    type: EnaioWorkflowEventType;
    name = "";
}
